<template>
<div class="modaladmin">
  <div class="modaladmin-content">
    <div>IME: <input type="text" v-model="achievement.name" /></div>
    <div>OPIS: <input type="text" v-model="achievement.description" /></div>
    <div>BODOVI: <input type="number" v-model="achievement.points" /></div>
    <div>BROJ KODOVA ZA ISPUNJENJE:
        <input type="number" v-model="achievement.numberOfAchievementCodesToFulfill">
    </div>
    <div>ACHIEVEMENT KODOVI:
        <multiselect v-model="selectedAchievementCodes" track-by="id" v-bind:custom-label="customLabel" v-bind:options="achievementCodes" v-bind:multiple="true" v-bind:close-on-select="false">
            <template slot="option" slot-scope="props">
                <span>{{ props.option.code }} {{ props.option.description }}</span>
            </template>
        </multiselect>
    </div>
    <div class="modaladmin-footer">
        <button type="button" v-bind:disabled="saveDisabled" v-on:click="save">SPREMI</button>
        <button type="button" v-on:click="$emit('cancel', achievement)">ODUSTANI</button>
    </div>
  </div>
  <a aria-label="Zatvori popup" class="close-modaladmin" v-on:click="$emit('cancel', achievement)"></a>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    name: "AddEditAchievementModal",
    components: {
        Multiselect
    },
    data() {
        return {
            selectedAchievementCodes: []
        }
    },
    props: {
        achievement: {},
        achievementCodes: Array
    },
    computed: {
        saveDisabled: function() {
            return !this.achievement.name || !this.achievement.name.length || !this.achievement.description || 
                !this.achievement.description.length || !this.achievement.points || isNaN(this.achievement.points) || this.achievement.points < 0 || 
                !this.achievement.numberOfAchievementCodesToFulfill || isNaN(this.achievement.numberOfAchievementCodesToFulfill) || 
                this.achievement.numberOfAchievementCodesToFulfill < 0;
        }
    },
    methods: {
        save: function() {
            this.achievement.achievementAchievementCodes = [];

            for(let achievementCode of this.selectedAchievementCodes)
                this.achievement.achievementAchievementCodes.push({achievementCode: achievementCode});

            this.$emit('save', this.achievement);
        },
        customLabel: function({ code, description }) {
            return `${code} ${description}`;
        }
    },
    created() {
        if(this.achievement.achievementAchievementCodes && this.achievement.achievementAchievementCodes.length)
            this.selectedAchievementCodes = [...this.achievement.achievementAchievementCodes.map(aac => aac.achievementCode)];
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>